import React from 'react'
import styled from '@emotion/styled'
import { useSelector } from 'hooks/redux'
import { useDispatch } from 'react-redux'
import strings from 'utils/strings'
import { themeColor } from 'utils/styles'

import { setDisplayAllLocations } from 'actions/dash'
import {
  getDisplayAllLocations,
  getShowPreProductionEditing,
  getDashVehicleSerialNumber,
} from 'selectors/dash'
import { getCanEditSwitchAndGauge } from 'selectors/authorization'

import { Checkbox } from 'components/patterns/Inputs'

const DisplayAllCheckbox = () => {
  const dispatch = useDispatch()

  const serialNumber = useSelector(getDashVehicleSerialNumber)
  const showAll = useSelector(getDisplayAllLocations)
  const shouldShow = useSelector(getShowPreProductionEditing, {
    serialNumber,
  })
  const canEdit = useSelector(getCanEditSwitchAndGauge, {
    serialNumber,
  })

  const handleOnChange = () => {
    dispatch(setDisplayAllLocations(!showAll))
  }

  if (!shouldShow || !canEdit) return null

  return (
    <StyledWrap>
      <Checkbox checked={showAll} onChange={handleOnChange}>
        {strings.display_all_possible_locations}
      </Checkbox>
    </StyledWrap>
  )
}

export default DisplayAllCheckbox

const StyledWrap = styled.div`
  padding: 16px;
  width: 100%;
  background: ${themeColor('sAndGDisplayAllLocationsBkgrd')};
  border-top: 1px solid ${themeColor('sAndGDisplayAllLocationsBorder')};
  border-bottom: 1px solid ${themeColor('sAndGDisplayAllLocationsBorder')};
`
